import { createRouter, createWebHashHistory } from "vue-router";
import { showMessage } from "@/utils/hooks/message"
import routes from './routes'
import i18n from "@/i18n"
import { getLangData } from "@/service/apiList/lang.js"
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'hash',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, left: 0 }
    }
  },
})

const _getLangData = async () => {
  // 获取语言JSON数据
  const reps = await getLangData();
  if (reps.code === 0) {
    sessionStorage.setItem("custom-lang", JSON.stringify(reps.payload));
  }
}

// Before each route evaluates...
router.beforeEach(async (to, from, next) => {
  // 全局语言配置
  let obj = sessionStorage.getItem("custom-lang",)
  if (typeof obj == 'undefined' || obj == '' || obj == null) {
    await _getLangData();
  }
  // 判断该路由是否需要登录权限
  let token = sessionStorage.getItem('is_login');
  if (to.meta.authRequired) {
    if (token) {
      // 判断页面权限
      if (to.meta.permission) {
        let permissions = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).permissions : [];
        if (permissions.filter(item => item == to.meta.permission || to.meta.permission.includes(item)).length == 0) {
          //message
          showMessage('danger', i18n.global.t('base.request403'))
          next('/homePage')
        } else {
          next()
        }
      } else {
        // 对于产品页面需要特殊处理
        // console.log(to);
        if (to.name == 'products') {
          // 需要判断params id 是否存在 是否有权限
          next()
        } else {
          next()
        }

      }
      // next()
    } else {
      next('/login')
    }
  } else {
    if (token) {
      // next(JSON.parse(token).permission_list.split(',')[0])
      next()
    } else {
      next()
    }
  }
})

export default router
